import { FlexContainer } from '@taxdown/piccolo-web';
import styled from 'styled-components';
import { pxToRem } from 'Styles/utils/utils';
import { MOBILE_WIDTH } from 'Styles/variables/sizes';

export const Box = styled(FlexContainer)`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${({ theme: { colors } }) => colors.white};
  border-radius: 10px;
  width: 100%;
  margin: 0 auto;
  max-width: ${pxToRem(450)};
  box-shadow: ${({ theme: { boxShadows } }) =>
    `${boxShadows.fds_elevation_500.x} ${boxShadows.fds_elevation_500.y} 4px ${boxShadows.fds_elevation_500.spread} ${boxShadows.fds_elevation_500.color}`};
`;

export const Header = styled(FlexContainer)`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: ${({ theme }) => theme.colors.grad_500};
  border-radius: 10px;
  width: 100%;
  box-shadow: ${({ theme: { boxShadows } }) =>
    `${boxShadows.fds_elevation_500.x} ${boxShadows.fds_elevation_500.y} 4px ${boxShadows.fds_elevation_500.spread} ${boxShadows.fds_elevation_500.color}`};
  padding: 6px;
`;

export const IconContainer = styled.div`
  position: absolute;
  top: 205px;
  align-items: center;
  justify-content: center;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    top: 220px;
  }
`;

export const ButtonsContainer = styled(FlexContainer)`
  display: flex;
  flex-direction: column;
  max-width: ${pxToRem(300)};
`;

export const BoxContent = styled(FlexContainer)`
  width: 100%;
  padding: ${({ theme: { spacing } }) => spacing.spacing_16};
`;

export const AmountContainer = styled(FlexContainer)`
  width: 100%;
  gap: ${({ theme: { reference } }) => reference.dimension_16};
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    gap: ${({ theme: { reference } }) => reference.dimension_04};
    svg {
      width: 30px;
    }
  }
`;
